import { render } from "./InspectionFeatures.vue?vue&type=template&id=02bbd571"
import script from "./InspectionFeatures.vue?vue&type=script&lang=js"
export * from "./InspectionFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/InspectionFeatures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02bbd571"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02bbd571', __exports__)) {
    api.reload('02bbd571', __exports__)
  }
  
  module.hot.accept("./InspectionFeatures.vue?vue&type=template&id=02bbd571", () => {
    api.rerender('02bbd571', render)
  })

}


export default __exports__